import {
    AddressPayload,
    completeEmailFlowOnboarding,
    createTemplateFlow,
    updateUserAddress,
} from '@/lib/api/email-flows';

/**
 * Executes all three steps of the onboarding process in sequence:
 * 1. Update user address
 * 2. Create template flow
 * 3. Mark onboarding as complete
 *
 * @param address - User's business address for email compliance
 * @param userId - ID of the user completing onboarding
 * @throws Error if any step of the onboarding process fails
 */
export async function executeOnboardingFlow(address: AddressPayload, userId: number): Promise<void> {
    // Step 1: Update user address
    await updateUserAddress(address);

    // Step 2: Create template flow
    await createTemplateFlow();

    // Step 3: Mark onboarding as complete
    await completeEmailFlowOnboarding(userId);
}
